// src/services/api.js
   import axios from 'axios'
   import { nakaApiBaseUrl } from './config'

   const apiClient = axios.create({
     baseURL: nakaApiBaseUrl,
     withCredentials: false,
     headers: {
       Accept: 'application/json',
       'Content-Type': 'application/json'
     }
   })

   export default {
     getNakaHistory() {
       return apiClient.get('/history/RAREPEPE.json')
     },
     getPFPInfos() {
       return apiClient.get('/PFPInfos.json')
     },
     getOpenSeaInfo() {
       return apiClient.get('/os/RAREPEPE.json')
     }
   }